module.exports = __webpack_public_path__ + "img/SubHeaderExample.d71b9a8b.png";